/* ---- Core ---- */
import { readonly, ref } from 'vue';

export function useSmsForm(): unknown {
  /* ---- State ---- */
  const isSmsFormCompleted = ref(false);
  const smsCode = ref();
  const changedValue = ref();

  /* ---- Handlers ---- */
  const onSmsFormComplete = (value: string) => {
    smsCode.value = value;
    isSmsFormCompleted.value = true;
  };

  const onSmsFormChange = (value: string) => {
    changedValue.value = value;
  };

  /* ---- return reactive value of composable ---- */
  return {
    isSmsFormCompleted: readonly(isSmsFormCompleted),
    onSmsFormComplete,
    onSmsFormChange,
    smsCode,
  };
}
